import AddToBasketRequestModel from '../../../generated/types/model/request/AddToBasketRequestModel';

export default class AddToBasketRequestViewModel extends AddToBasketRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
